/**
 * 页面级返回标题栏：非 App 环境显示，App 环境使用 App 的 header 故不展示。
 * 用于邀请返佣、合伙人等页面的统一 header。
 */
import React from 'react';
import { Platform, Util, Hooks } from '@xt/xtbase';
import styles from './index.module.less';

const { getUrl } = Util;
const { useTranslation } = Hooks;

const BackArrowSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M12.5 15L7.5 10L12.5 5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** 与 ssr-web-user-center `accounts/user/[tabKey].tsx` 首页按钮一致 */
const HomeIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

export default function BackHeader({ title = '', onBack, right, showHome = false }) {
  const t = useTranslation();
  if (Platform.isInApp()) return null;

  const handleBack = () => {
    if (typeof onBack === 'function') onBack();
    else if (typeof window !== 'undefined' && window.history.length > 1) window.history.back();
  };

  return (
    <div className={styles.backHeader}>
      <div className={styles.leftGroup}>
        <div className={styles.backButton} onClick={handleBack} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleBack()} aria-label={t('activity.back') || 'Back'}>
          <BackArrowSvg />
        </div>
        {showHome ? (
          <a href={getUrl('/')} className={styles.homeButton} aria-label={t('header.derivativesOverview2') || 'Home'}>
            <HomeIconSvg />
          </a>
        ) : null}
      </div>
      <p className={styles.title}>{title}</p>
      <div className={styles.rightSlot}>{right != null ? right : <span style={{ width: '20px' }} />}</div>
    </div>
  );
}
